import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-hearts': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M353.6 304.6C327.7 312.9 289.2 317.7 248 317.7S168.4 312.9 142.4 304.6C132.6 301.5 123 309.9 124.7 319.9 132.6 367.1 196 399.9 248 399.9S363.3 367 371.3 319.9C372.9 310.1 363.6 301.5 353.6 304.6zM200.8 255.7C205.3 256.9 210 254.2 211.3 249.7L230.7 179.8C236.3 159.5 223.3 138.7 201.9 135.3 183.3 132.3 165.5 145.1 160.4 163.2L158.4 170.3 151.3 168.4C133.1 163.7 113.1 172.7 106.4 190.4 98.7 210.6 110.2 232.3 130.6 237.6L200.8 255.7zM389.6 190.4C382.9 172.8 362.9 163.7 344.7 168.4L337.6 170.3 335.6 163.2C330.6 145.1 312.8 132.3 294.1 135.3 272.7 138.7 259.7 159.5 265.3 179.8L284.7 249.7C285.9 254.2 290.6 256.9 295.2 255.7L365.4 237.5C385.8 232.2 397.3 210.6 389.6 190.4zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-hearts.js
// module id = ZWmE
// module chunks = 144